import { Avatar, Badge } from '@mui/material';

type AvatarImagesProps = {
  src: string,
  alt: string,
  profileIcon: React.ReactElement,
  style:  React.CSSProperties;
};

const AvatarImages = (
  {
    src, alt, profileIcon, style,
  }:
    AvatarImagesProps,
):JSX.Element => {
  return (
    <Badge badgeContent={
      profileIcon
    }
    anchorOrigin={
      {
        vertical: 'bottom',
        horizontal: 'right',
      }
    }
    >
      <Avatar
        alt={ alt }
        src={ src }
        sx={ style }
      />
    </Badge>
  );
};
export default AvatarImages;
